import Query from "../models/query";
import QueryService from "../services/queryService";
import Vue from "vue";
import SelectedMixin from "../../formability/visualizationBuilder/mixins/selectedMixin";

export default {
  mixins: [SelectedMixin],
  data: function () {
    return {
      query: new Query({direction: 'desc'}),
      queryService: <QueryService>null,
      fetch: null,
      searchProgress: null,
    };
  },
  beforeMount() {
    this.fetch = this.queryService.fetch.bind(this.queryService);
  },
  created() {
    this.queryService = new QueryService({
      endpoint: `/organizations/${this.selectedOrganization.id}/search_users`
    });
  },
  computed: {
    q: {
      get() {
        return this.query.q;
      },
      set(value) {
        if (value.length > 0) {
          this.searchProgress = 'Searching...';
          this.query.q = value;
          this.fetch(this.query).then(result => {
            this.query.results = result;
            this.updateSearchProgress();
          }).catch(err => {
            console.error(err)
          });
        } else {
          this.searchProgress = null;
          this.query.clear();
          this.queryService.kill();
        }
      }
    },
    hasQ(): boolean {
      return this.q.length > 0;
    },
    usersFromQuery(): object[] {
      return this.query.results.users;
    },
    hasUsersFromQuery(): boolean {
      return this.usersFromQuery && this.usersFromQuery.length > 0;
    },
    currentUserId(): string {
      return this.currentUser.id;
    },
  },
  methods: {
    resetModal(event = null): void {
      this.query.clear();
      this.queryService.kill();
      this.emitHideModal(event);
    },
    resetSearch(): void {
      this.query.clear();
    },
    resetSearchOrModal(): void {
      if (this.hasQ) {
        this.resetSearch();
      } else {
        this.resetModal();
      }
    },
    // may be overwritten in mixed-in component
    updateSearchProgress(): void {
      if (this.hasQ && !this.hasUsersFromQuery) {
        this.searchProgress = 'No matching results';
      } else {
        this.searchProgress = null;
      }
    },
  },
};
